import { SweetAlertService } from '../../../_services/sweetalert.service';
import { ValidationService } from '../../../_services/validation.service';

export class BaseComponent {
    protected swalService: SweetAlertService;
    protected validationService: ValidationService;
    constructor() {
        this.swalService = new SweetAlertService();
        this.validationService = new ValidationService();
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/base.component.ts